<template>
  <div class="main-form">
    <div class="gap"></div>
    <div v-if="!submitted" class="sub-form">
      <div class="row" style="margin-bottom: 2rem !important;">
        <div class="col-10">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Copy and paste the link here to pull your job"
              v-model="urlLink"
            />
            <button class="input-group-append" @click="fetchJobInfoUsingUrl">
              <div class="find-jobs-button vertical-center" align="middle">
                <b> Go</b>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="row">
        <div class="col-10">
          <div class="row s-header justify-content-between">
            <div
              class="numH"
              @click="goToPage(1)"
              v-bind:class="[
                { active: isActive(1) },
                { completeH: pages[0].completed() }
              ]"
            >
              <div>
                <v-icon v-bind:class="[{ complete: pages[0].completed() }]">
                  {{
                  pages[0].icon
                  }}
                </v-icon>
              </div>
              <div>Basics</div>
            </div>
            <div
              class="numH"
              @click="goToPage(2)"
              v-bind:class="[
                { active: isActive(2) },
                { completeH: pages[1].completed() }
              ]"
            >
              <div>
                <v-icon v-bind:class="[{ complete: pages[1].completed() }]">
                  {{
                  pages[1].icon
                  }}
                </v-icon>
              </div>
              <div>Responsibilities</div>
            </div>
            <div
              class="numH"
              @click="goToPage(3)"
              v-bind:class="[
                { active: isActive(3) },
                { completeH: pages[2].completed() }
              ]"
            >
              <div>
                <v-icon v-bind:class="[{ complete: pages[2].completed() }]">
                  {{
                  pages[2].icon
                  }}
                </v-icon>
              </div>
              <div>Requirements</div>
            </div>
            <div
              class="numH"
              @click="goToPage(4)"
              v-bind:class="[
                { active: isActive(4) },
                { completeH: pages[3].completed() }
              ]"
            >
              <div>
                <v-icon v-bind:class="[{ complete: pages[3].completed() }]">
                  {{
                  pages[3].icon
                  }}
                </v-icon>
              </div>
              <div>Salary & Benefits</div>
            </div>
            <div
              class="numH"
              @click="goToPage(5)"
              v-bind:class="[
                { active: isActive(5) },
                { completeH: pages[4].completed() }
              ]"
            >
              <div>
                <v-icon v-bind:class="[{ complete: pages[4].completed() }]">
                  {{
                  pages[4].icon
                  }}
                </v-icon>
              </div>
              <div>Deadlines</div>
            </div>
          </div>
          <div v-if="user && page === 1" class="row usr-wrap">
            <div class="col-3 no-padding ttl-job usr">
              <div>Posting as:</div>
              <div>{{ user.user_name }}</div>
            </div>
            <div class="col-3 no-padding ttl-job usr">
              <div>Role:</div>
              <div>{{ user.role }}</div>
            </div>
            <div class="col-4 no-padding ttl-job usr">
              <div>Contact:</div>
              <div>{{ user.phone || user.email }}</div>
            </div>
            <div class="col-2 no-padding ttl-job usr">
              <div class="row" style="height: 100%">
                <div class="mx-auto my-auto">
                  <span @click="changePostingUser" class="link-back">Change</span>
                </div>
              </div>
            </div>
            <div class="col-12 no-padding ttl-job usr">
              <div class="ttl-job">Job Source</div>
              <div class="ttl-inp">
                <v-select
                  :items="job_sources"
                  v-model="job_source"
                  label="Job Source"
                  item-text="name"
                  item-value="value"
                  solo
                  outline
                ></v-select>
              </div>
            </div>
          </div>
          <div class="s-body">
            <div v-if="page === 1">
              <div>
                <div class="ttl-job">
                  Job Title
                  <span style="font-size: 1.6rem; color: var(--button-delete-color)">*</span>
                </div>
                <div class>
                  <v-combobox
                    outline
                    solo
                    append-icon="bopon"
                    v-model="title"
                    label="e.g: Sales Executive"
                    :search-input.sync="titleQuery"
                    :items="titleItems"
                    item-text="job_title"
                    @change="resetTitleQuery"
                    @input="pageOneCompleted"
                    @keyup="callBlur"
                    error
                    :rules="titleRules"
                  ></v-combobox>
                </div>
                <div class="ttl-job">No of Vacancy</div>
                <div class="ttl-inp">
                  <v-text-field v-model="no_of_vacancy" label="e.g: 10" mask="####" outline solo></v-text-field>
                </div>
                <div class="ttl-job">
                  Job Type
                  <span style="font-size: 1.6rem; color: var(--button-delete-color)">*</span>
                </div>
                <div class="row ttl-inp chips">
                  <div
                    v-if="positions[0].value"
                    @click="removePosition(0)"
                    class="selectChip activeChip"
                  >Full Time</div>
                  <div v-else @click="addPosition(0)" class="selectChip">Full Time</div>
                  <div
                    v-if="positions[1].value"
                    @click="removePosition(1)"
                    class="selectChip activeChip"
                  >Part Time</div>
                  <div v-else @click="addPosition(1)" class="selectChip">Part Time</div>
                  <div
                    v-if="positions[2].value"
                    @click="removePosition(2)"
                    class="selectChip activeChip"
                  >Internship</div>
                  <div v-else @click="addPosition(2)" class="selectChip">Internship</div>
                  <div
                    v-if="positions[3].value"
                    @click="removePosition(3)"
                    class="selectChip activeChip"
                  >Contractual</div>
                  <div v-else @click="addPosition(3)" class="selectChip">Contractual</div>
                  <div
                    v-if="positions[4].value"
                    @click="removePosition(4)"
                    class="selectChip activeChip"
                  >Remote</div>
                  <div v-else @click="addPosition(4)" class="selectChip">Remote</div>
                </div>
                <div class="ttl-job">
                  Experience Level
                  <span
                    style="font-size: 1.6rem; color: var(--button-delete-color)"
                  >*</span>
                </div>
                <div class="row ttl-inp chips">
                  <div
                    v-if="experiences[0].value"
                    @click="removeExperience(0)"
                    class="selectChip activeChip"
                  >Junior (0-2 yrs)</div>
                  <div v-else @click="addExperience(0)" class="selectChip">Junior (0-2 yrs)</div>
                  <div
                    v-if="experiences[1].value"
                    @click="removeExperience(1)"
                    class="selectChip activeChip"
                  >Associate (2-5 yrs)</div>
                  <div v-else @click="addExperience(1)" class="selectChip">Associate (2-5 yrs)</div>
                  <div
                    v-if="experiences[2].value"
                    @click="removeExperience(2)"
                    class="selectChip activeChip"
                  >Senior (5-7 yrs)</div>
                  <div v-else @click="addExperience(2)" class="selectChip">Senior (5-7 yrs)</div>
                  <div
                    v-if="experiences[3].value"
                    @click="removeExperience(3)"
                    class="selectChip activeChip"
                  >Staff (7+ yrs)</div>
                  <div v-else @click="addExperience(3)" class="selectChip">Staff (7+ yrs)</div>
                </div>
              </div>
            </div>
            <div v-if="page === 2">
              <div>
                <div class="ttl-job">
                  Job Description / Context
                  <span
                    style="font-size: 1.6rem; color: var(--button-delete-color)"
                  >*</span>
                </div>
                <div class="ttl-inp" style="margin-bottom: 2rem">
                  <quill-editor
                    ref="myTextEditor"
                    v-model="details"
                    :options="editorOption"
                    @change="saveDetails"
                  ></quill-editor>
                  <div v-if="job_description && job_description.length >= 10000" style="text-align: right; margin: 0.5rem 0; color: var(--error-color)">Length too long</div>
                </div>
                <div class="ttl-job">Job Responsibilities</div>
                <div class="ttl-inp" style="margin-bottom: 2rem">
                  <quill-editor
                    ref="myTextEditor"
                    v-model="responsibilities"
                    :options="editorOption"
                    @change="saveResponsibilities"
                  ></quill-editor>
                  <div v-if="job_responsibilities && job_responsibilities.length >= 10000" style="text-align: right; margin: 0.5rem 0; color: var(--error-color)">Length too long</div>
                </div>
              </div>
            </div>
            <div v-if="page === 3">
              <div>
                <div class="ttl-job">
                  Required Skills
                  <span
                    style="font-size: 1.6rem; color: var(--button-delete-color)"
                  >*</span>
                  <span v-if="reqSkills.length > 20" style="text-align: right; color: var(--error-color); float: right;">Not more than 20 skills</span>
                </div>
                <div class>
                  <v-combobox
                    outline
                    solo
                    multiple
                    append-icon="bopon"
                    v-model="reqSkills"
                    label="e.g: Leadership, MS Word"
                    :search-input.sync="skillQuery"
                    :items="skillItems"
                    item-text="skill_name"
                    @keyup.188="insertSkillsByComma"
                    @paste="insertSkillsByPasting"
                    @change="resetSearchQuery"
                    @focus="showSelectedSkills"
                    @blur="callBlurSkills"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip small>
                        <span style="max-width: 40.0rem;overflow: hidden">{{ item.skill_name }}</span>
                        <v-icon
                          color="grey"
                          @click="removeSkill(index)"
                          style="margin-bottom: 0.1rem; margin-left: 0.5rem"
                          size="16"
                        >cancel</v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                </div>
                <div class="ttl-job" style="margin-bottom: 1rem">
                  Educational Requirements
                  <v-icon
                    @click="addnewDegrees"
                    style="color: var(--button-color); margin-top: 0.5rem"
                  >mdi-plus-box</v-icon>
                </div>
                <div v-for="(item, index) in newDegrees" class="row">
                  <div class="col-md-5 no-padding">
                    <v-autocomplete
                      v-model="item.degree"
                      solo
                      outline
                      label="Degree"
                      :items="degreeItems"
                      item-text="degree_name"
                      return-object
                      :rules="nameRules"
                    ></v-autocomplete>
                  </div>
                  <div class="col-md-6 no-padding" style="padding-left: 1rem !important;">
                    <v-combobox
                      outline
                      solo
                      append-icon="bopon"
                      v-model="item.major"
                      label="Major (e.g. Computer Science, Accounting)"
                      :items="majorItems"
                      item-text="major_name"
                      @keyup="queryMajor($event)"
                      @blur="setMajor($event, index)"
                    ></v-combobox>
                  </div>
                  <div class="col-md-1 no-padding">
                    <v-icon
                      @click="deleteNewRow(index)"
                      style="float: right; margin-top: 0.5rem; color: var(--button-delete-color)"
                    >mdi-close</v-icon>
                  </div>
                </div>
                <div class="ttl-job">Additional Requirements / Nice to have</div>
                <div class="ttl-inp" style="margin-bottom: 2rem">
                  <quill-editor
                    ref="myTextEditor"
                    v-model="niceToHave"
                    :options="editorOption"
                    @change="saveNicetoHave"
                  ></quill-editor>
                  <div v-if="nice_to_have.length >= 10000" style="text-align: right; margin: 0.5rem 0; color: var(--error-color)">Length too long</div>
                </div>
              </div>
            </div>
            <div v-if="page === 4">
              <div>
                <div class="ttl-job">Salary Range</div>
                <div class="row ttl-inp">
                  <v-text-field
                    v-model="minSalary"
                    outline
                    solo
                    mask="##########"
                    label="Minimum Salary"
                    append-icon="mdi-currency-bdt"
                  ></v-text-field>
                  <div style="margin: 0 1rem"></div>
                  <v-text-field
                    v-model="maxSalary"
                    solo
                    outline
                    mask="##########"
                    label="Maximum Salary"
                    append-icon="mdi-currency-bdt"
                    :error-messages="salaryRangeErrors"
                  ></v-text-field>
                </div>
                <div class="ttl-job">Benefits</div>
                <div class="ttl-inp" style="margin: 0 0 2rem 0">
                  <quill-editor
                    ref="myTextEditor"
                    v-model="benefits"
                    :options="editorOption"
                    @change="saveBenefits"
                  ></quill-editor>
                  <div v-if="job_benefits.length >= 10000" style="text-align: right; margin: 0.5rem 0; color: var(--error-color)">Length too long</div>
                </div>
                <div class="row">
                  <div class="ttl-job">
                    <span style="font-size: 1.6rem; color: var(--button-delete-color)">*</span>Salary Basis:
                  </div>
                  <div style="margin-left: 2rem">
                    <v-radio-group v-model="salaryBasis" row>
                      <v-radio id="inp1" value="monthly"></v-radio>
                      <span style="margin-right: 1.5rem; margin-left: -0.5rem">Monthly</span>
                      <v-radio id="inp2" value="annually"></v-radio>
                      <span style="margin-right: 1.5rem; margin-left: -0.5rem">Annual</span>
                    </v-radio-group>
                  </div>
                </div>
                <div class="row salary">
                  <div class="ttl-job">
                    <span style="font-size: 1.6rem; color: var(--button-delete-color)">*</span>Is the salary negotiable?
                  </div>
                  <div style="margin-left: 2rem">
                    <v-radio-group v-model="negotiable" row>
                      <v-radio :value="true"></v-radio>
                      <span style="margin-right: 1.5rem; margin-left: -0.5rem">Yes</span>
                      <v-radio :value="false"></v-radio>
                      <span style="margin-right: 1.5rem; margin-left: -0.5rem">No</span>
                    </v-radio-group>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="page === 5">
              <div>
                <div class="ttl-job">Job Location <span style="font-size: 1.6rem; color: var(--button-delete-color)">*</span></div>
                <div class>
                  <v-text-field
                          v-model="location"
                          outline solo
                          @input="pageFiveCompleted"
                  ></v-text-field>
                  <div v-if="location && location.length >= 300" style="text-align: right; margin-top: -2rem; color: var(--error-color)">Too long</div>
                </div>
                <div class="ttl-job">
                  <span>Req Id</span>
                  <span>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon class="info-icon-class" v-on="on">info</v-icon>
                      </template>
                      <span>
                        Requisition Id for tracking your job for future
                        reference
                      </span>
                    </v-tooltip>
                  </span>
                </div>
                <div class>
                  <v-text-field mask="##########" v-model="req_id" outline solo></v-text-field>
                </div>
                <div class="ttl-job">Job Open Date  <span style="font-size: 1.6rem; color: var(--button-delete-color)">*</span></div>
                <div class>
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="29.0rem"
                  >
                    <v-text-field
                      outline
                      solo
                      slot="activator"
                      v-model="openingDateFormatted"
                      label="Application Opening"
                      @blur="opening = parseDate(openingDateFormatted)"
                      readonly
                      prepend-inner-icon="date_range"
                    ></v-text-field>
                    <v-date-picker
                      :min="setMinOpeningDate()"
                      v-model="opening"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="ttl-job">Application Deadline  <span style="font-size: 1.6rem; color: var(--button-delete-color)">*</span></div>
                <div class>
                  <v-menu
                    ref="menu1"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="29.0rem"
                  >
                    <v-text-field
                      outline
                      solo
                      slot="activator"
                      v-model="deadlineDateFormatted"
                      label="Application Deadline"
                      @blur="deadline = parseDate(deadlineDateFormatted)"
                      readonly
                      prepend-inner-icon="date_range"
                    ></v-text-field>
                    <v-date-picker
                      :min="setMinDeadLine()"
                      :max="setMaxDeadLine()"
                      v-model="deadline"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="row salary">
                  <div class="ttl-job">
                    <span style="font-size: 1.6rem; color: var(--button-delete-color)">*</span>Allow candidates to send message
                  </div>
                  <div style="margin-left: 2rem">
                    <v-switch v-model="allow_message"></v-switch>
                  </div>
                </div>
              </div>
            </div>
            <div v-bind:class="[{ btm: page === 5 && !showPreview }]" class="next-button">
              <button
                v-if="page !== 1"
                @click="goToPreviousPage"
                style="margin-right: 1.0rem; float: left;"
                class="btn btn-prv-outline"
              >
                <span>Previous</span>
              </button>
              <button v-if="page < 5" @click="goToNextPage" class="btn btn-next-outline">
                <span>Next</span>
              </button>
              <button
                v-if="page === 5 && showPreview"
                @click="openPreviewModal"
                class="btn btn-next-outline"
              >
                <span>View</span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-2 no-padding">
          <div v-bind:class="[{ bTop: isAdmin }]" class="preview">
            <div class="previewIcon">
              <v-icon v-bind:class="[{ complete: showPreview }]" size="36">
                {{
                pages[5].icon
                }}
              </v-icon>
            </div>
            <div v-bind:class="[{ completeH: showPreview }]" class="previewText">{{ pages[5].text }}</div>
            <div v-bind:class="[{ activePreview: showPreview }]" class="buttons">
              <div @click="openPreviewModal" class="right-button">
                <span>
                  <v-icon class="icon-right-butons">mdi-eye</v-icon>
                </span>Preview
              </div>
              <div
                v-if="showPublish"
                @click="publishJob"
                class="right-button"
                id="btn-publish-job-emp"
              >
                <span>
                  <v-icon class="icon-right-butons">mdi-publish</v-icon>
                </span>Publish
              </div>
              <div v-if="isAdmin" @click="adminJobPost" class="right-button">
                <span>
                  <v-icon class="icon-right-butons">mdi-publish</v-icon>
                </span>Post Job
              </div>
              <div v-if="showDraft" @click="saveJob" class="right-button" id="btn-save-job-emp">
                <span>
                  <v-icon class="icon-right-butons">mdi-bookmark</v-icon>
                </span>Save
              </div>
              <div v-if="existingJob" @click="cancelJobPosting" class="right-button">
                <span>
                  <v-icon class="icon-right-butons">mdi-close-box</v-icon>
                </span>Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 70vh;width:100%" v-if="loading" class="row">
        <loader></loader>
      </div>
    </div>
    <div v-else class="row sub-form" style="height: 60rem;">
      <div style="height:100%; width:100%" v-if="loading">
        <loader></loader>
      </div>
      <div v-else class="message-box">
        <div v-if="successful">
          <v-icon
            style="color: var(--button-save-color)"
            size="100"
          >mdi-checkbox-marked-circle-outline</v-icon>
          <div class="suc-text">
            <div style="font-size: 3.2rem; margin: .5rem 0 1.0rem 0">Congratulations!</div>
            {{ message }}
          </div>
          <div style="margin-top: 3.0rem">
            <button
              v-if="goToPending"
              @click="goToPendingJob"
              class="btn btn-save"
            >Go to pending page</button>
            <button v-else @click="goToDraftJob" class="btn btn-save">Go back to draft jobs</button>
          </div>
        </div>
        <div v-else>
          <v-icon style="color: var(--button-delete-color)" size="100">mdi-close-circle-outline</v-icon>
          <div class="failure">
            <div style="font-size: 3.2rem; margin: .5rem 0 1.0rem 0">Sorry!</div>
            {{ message }}
          </div>
          <div style="
            margin-top: 3.0rem;
            width:100%;
            display:flex;
            flex-direction:row;
            justify-content:center;
            align-items:center">
            <button
              @click="goBackToPreview"
              style="margin-right: 1.0rem"
              class="btn btn-save"
            >Previous Page</button>
            <button @click="cancelJobPosting" class="btn btn-cancel">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <v-dialog
        @keydown.esc="previewModal = false"
        persistent
        max-width="100rem"
        v-model="previewModal"
      >
        <v-card class="card-padding" max-width="100%">
          <job-preview
            :key="prevCheck"
            v-bind:job="jobObj"
            v-on:close-preview="previewModal = false"
          ></job-preview>
        </v-card>
      </v-dialog>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar" class="snack">
      <div style="text-align: center; width: 100%;">
        <span style="padding-right:1.0rem;">
          <v-icon color="white">{{ snackIcon }}</v-icon>
        </span>
        {{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Loader from "../../global-components/loader";
import { quillEditor } from "vue-quill-editor";
import {
  GET_AUTO_SUGGEST,
  IMPORT_JOB_USING_URL
} from "../../../Api/common_api";
import JobPreview from "./posted-job-preview";
import * as FILTERS from "../../../filters";
import { GET_LOCAL_TIME_FROM_UTC } from "../../../globalFunctions";
import { POST_A_JOB } from "../../../Api/employer_api";
import { REMOVE_HTML_TAGS, REMOVE_WHITE_SPACES } from "../../../filters";
export default {
  name: "post-a-job",
  components: {
    quillEditor,
    JobPreview,
    Loader
  },
  props: {
    job: Object,
    from: String,
    user: Object
  },
  data: function() {
    return {
      bgColor: "#454545",
      timeOut: 5000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
      nameRules: [v => !!v || "Required"],
      titleRules: [v => !!v || "Required",
          v => typeof v === "object" || (v.length > 3 && v.length < 128) || "Must be between 4 to 127 characters"],
      page: 1,
      pages: [
        {
          name: "Basics",
          value: 1,
          icon: "mdi-circle-outline",
          title: false,
          type: false,
          level: false,
          completed: function() {
            if (this.title && this.type && this.level) {
              this.icon = "mdi-check-circle";
              return true;
            }
            this.icon = "mdi-circle-outline";
            return false;
          }
        },
        {
          name: "Responsibilities",
          value: 2,
          icon: "mdi-circle-outline",
          details: false,
          completed: function() {
            if (this.details) {
              this.icon = "mdi-check-circle";
              return true;
            }
            this.icon = "mdi-circle-outline";
            return false;
          }
        },
        {
          name: "Requirements",
          value: 3,
          icon: "mdi-circle-outline",
          skills: false,
          completed: function() {
            if (this.skills) {
              this.icon = "mdi-check-circle";
              return true;
            }
            this.icon = "mdi-circle-outline";
            return false;
          }
        },
        {
          name: "Salary & Benefits",
          value: 4,
          icon: "mdi-circle-outline",
          item: false,
          completed: function() {
            if (this.item) {
              this.icon = "mdi-check-circle";
              return true;
            }
            this.icon = "mdi-circle-outline";
            return false;
          }
        },
        {
          name: "Deadline",
          value: 5,
          icon: "mdi-circle-outline",
          item: false,
          completed: function() {
            if (this.item) {
              this.icon = "mdi-check-circle";
              return true;
            }
            this.icon = "mdi-circle-outline";
            return false;
          }
        },
        {
          name: "Preview",
          value: 6,
          text: "Job preview is not ready",
          icon: "mdi-close-circle",
          valid: false
        }
      ],
      editorOption: {
        placeholder: "",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            ['link'],
            [{ list: "ordered" }, { list: "bullet" }]
          ]
        }
      },
      positions: [
        {
          name: "fulltime",
          value: false
        },
        {
          name: "parttime",
          value: false
        },
        {
          name: "internship",
          value: false
        },
        {
          name: "contractual",
          value: false
        },
        {
          name: "remote",
          value: false
        }
      ],
      experiences: [
        {
          name: "junior",
          value: false
        },
        {
          name: "associate",
          value: false
        },
        {
          name: "senior",
          value: false
        },
        {
          name: "staff",
          value: false
        }
      ],
      title: null,
      titleItems: [],
      titleQuery: "",
      no_of_vacancy: null,
      position_type: [],
      seniority_level: [],
      details: ``,
      job_description: "",
      responsibilities: ``,
      job_responsibilities: "",
      benefits: ``,
      job_benefits: "",
      minSalary: null,
      maxSalary: null,
      salaryBasis: "monthly",
      negotiable: false,
      reqSkills: [],
      skillItems: [],
      skillQuery: "",
      degreeItems: [],
      majorItems: [],
      niceToHave: ``,
      nice_to_have: "",
      location: null,
      req_id: null,
      menu1: false,
      deadline: "",
      deadlineDateFormatted: "",
      menu2: false,
      opening: "",
      openingDateFormatted: "",
      allow_message: false,
      previewModal: false,
      prevCheck: 0,
      jobObj: undefined,
      existingJob: false,
      showDraft: true,
      showPublish: true,
      loading: false,
      submitted: false,
      successful: false,
      color: "#3b32ef",
      message: "",
      isAdmin: false,
      job_sources: [
        {
          name: "On-Request",
          value: 1
        },
        {
          name: "Bdjobs",
          value: 2
        },
        {
          name: "Facebook",
          value: 3
        },
        {
          name: "Linkedin",
          value: 4
        }
      ],
      job_source: null,
      newDegrees: [],
      urlLink: "",
      timeout: null,
    };
  },
  methods: {
    setMajor(major, ind){
        if(major.target.value){
        const self = this;
        self.newDegrees[ind].major = major.target.value
        }
    },
    callBlur(ev){
        const self = this;
        if(self.title && typeof self.title === "object");
        else {
          self.title = ev.target.value;
        }
        self.pageOneCompleted()
    },
    callBlurSkills(ev){
        const self = this;
        self.pageThreeCompleted()
        clearTimeout(self.timeout)
        if(ev && ev.type === "blur") {
            self.timeout = setTimeout(function() {
                for (let i = 0; i < self.reqSkills.length; i++) {
                    if(self.reqSkills[i].skill_name.length < 1 || self.reqSkills[i].skill_name.length > 63) {
                        self.reqSkills.splice(i,1)
                    }
                }
            }, 100);
        }
    },
    resetAllValues() {
      const self = this;
      self.positions = [
        {
          name: "fulltime",
          value: false
        },
        {
          name: "parttime",
          value: false
        },
        {
          name: "internship",
          value: false
        },
        {
          name: "contractual",
          value: false
        },
        {
          name: "remote",
          value: false
        }
      ];
      self.experiences = [
        {
          name: "junior",
          value: false
        },
        {
          name: "associate",
          value: false
        },
        {
          name: "senior",
          value: false
        },
        {
          name: "staff",
          value: false
        }
      ];
      self.title = null;
      self.no_of_vacancy = null;
      self.position_type = [];
      self.seniority_level = [];
      self.details = ``;
      self.job_description = "";
      self.responsibilities = ``;
      self.job_responsibilities = "";
      self.benefits = ``;
      self.job_benefits = "";
      self.minSalary = null;
      self.maxSalary = null;
      self.salaryBasis = "monthly";
      self.negotiable = false;
      self.reqSkills = [];
      self.niceToHave = ``;
      self.nice_to_have = "";
      self.location = null;
      self.req_id = null;
      self.allow_message = false;
      self.newDegrees = [];
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      self.opening = tomorrow.toISOString().substr(0, 10);
      tomorrow.setDate(tomorrow.getDate() + 29);
      self.deadline = tomorrow.toISOString().substr(0, 10);
      self.pages[0].title = false;
      self.pages[0].type = false;
      self.pages[0].level = false;
      self.pages[1].details = false;
      self.pages[2].skills = false;
      self.pages[3].item = false;
      self.pages[4].item = false;
    },
    isActive(page) {
      const self = this;
      return self.page === page;
    },
    goToPage(page) {
      const self = this;
      if (page > 0 && page < 6) {
        self.page = page;
        if (page === 4) self.pageFourCompleted()
      }
    },
    goToNextPage() {
      const self = this;
      if (self.page < 5) self.page = self.page + 1;
      if (self.page === 4) self.pageFourCompleted()
    },
    goToPreviousPage() {
      const self = this;
      if (self.page > 1 && self.page < 6) self.page = self.page - 1;
    },
    addPosition(index) {
      const self = this;
      self.positions[index].value = !self.positions[index].value;
      self.position_type.push(self.positions[index].name);
      self.pages[0].type = true;
    },
    removePosition(index) {
      const self = this;
      let ind = self.position_type.indexOf(self.positions[index].name);
      if (ind !== -1) self.position_type.splice(ind, 1);
      self.positions[index].value = !self.positions[index].value;
      if (self.position_type.length < 1) {
        self.pages[0].type = false;
      }
    },
    addExperience(index) {
      const self = this;
      self.experiences[index].value = !self.experiences[index].value;
      self.seniority_level.push(self.experiences[index].name);
      self.pages[0].level = true;
    },
    removeExperience(index) {
      const self = this;
      let ind = self.seniority_level.indexOf(self.experiences[index].name);
      if (ind !== -1) self.seniority_level.splice(ind, 1);
      self.experiences[index].value = !self.experiences[index].value;
      if (self.seniority_level.length < 1) {
        self.pages[0].level = false;
      }
    },
    saveDetails(ev) {
      const self = this;
      self.job_description = ev.text.replace("↵", " ");
      self.pageTwoCompleted()
    },
    saveResponsibilities(ev) {
      const self = this;
      self.job_responsibilities = ev.text.replace("↵", " ");
      self.pageTwoCompleted()
    },
    saveNicetoHave(ev) {
      const self = this;
      self.nice_to_have = ev.text.replace("↵", " ");
      self.pageThreeCompleted()
    },
    saveBenefits(ev) {
      const self = this;
      self.job_benefits = ev.text.replace("↵", " ");
      self.pageFourCompleted()
    },
    setMinOpeningDate() {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().substr(0, 10);
    },
    setMinDeadLine() {
      if (this.opening) {
        let tomorrow = new Date(this.opening);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().substr(0, 10);
      }
    },
    setMaxDeadLine() {
      if (this.opening) {
        let tomorrow = new Date(this.opening);
        tomorrow.setDate(tomorrow.getDate() + 29);
        return tomorrow.toISOString().substr(0, 10);
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSelectedSkills() {
      const self = this;
      self.skillItems = self.reqSkills;
    },
    resetSearchQuery() {
      const self = this;
      self.skillQuery = "";
      self.pageThreeCompleted();
    },
    resetTitleQuery() {
      const self = this;
      self.titleQuery = "";
    },
    queryTitle: function(v) {
      const self = this;
      let query = v.trim();
      if (
        query.length > 0 &&
        query.length < 20 &&
        query.charAt(query.length - 1) !== ","
      ) {
        GET_AUTO_SUGGEST(query, self.$constants.QUERY_ACTION.TITLE)
          .then(function(response) {
            self.titleItems = [];
            self.titleItems = response;
          })
          .catch(function() {});
      }
    },
    insertSkillsByPasting() {
      const self = this;
      self.timeout = setTimeout(function() {
        let query = self.skillQuery.trim();
        if (query !== "") {
          let items;
          if (query.charAt(query.length - 1) === ",")
          query = query.substring(0, query.length - 1);
          items = query.split(",");
          for (let i = 0; i < items.length; i++) {
              if(items[i].length > 0 && items[i].length < 64) {
                  self.reqSkills.push({
                    skill_name: items[i]
                  })
              } else {
                  alert(items[i] + ' is too long')
              }
          }
          self.skillQuery = "";
        }
      }, 100);
    },
    insertSkillsByComma() {
      const self = this;
      let query = self.skillQuery.trim();
      query = query.substring(0, query.length - 1);
      if(query.length > 0 && query.length < 64) {
          self.reqSkills.push({
              skill_name: query
          });
      } else {
          alert(query + ' is too long')
      }
      self.skillQuery = "";
    },
    querySkills: function(v) {
      const self = this;
      let query = v.trim();
      if (
        query.length > 0 &&
        query.length < 20 &&
        query.charAt(query.length - 1) !== ","
      ) {
        GET_AUTO_SUGGEST(query, self.$constants.QUERY_ACTION.SKILL)
          .then(function(response) {
            self.skillItems = [];
            self.skillItems = response;
          })
          .catch(function() {});
      }
    },
    removeSkill(index) {
      const self = this;
      self.reqSkills.splice(index, 1);
    },
    queryMajor(v) {
      const self = this;
      let query = v.target.value.trim();
      if (
        query.length > 0 &&
        query.length < 20 &&
        query.charAt(query.length - 1) !== ","
      ) {
        GET_AUTO_SUGGEST(query, self.$constants.QUERY_ACTION.MAJOR)
          .then(function(response) {
            self.majorItems = [];
            self.majorItems = response;
          })
          .catch(function() {});
      }
    },
    fetchDegrees() {
      const self = this;
      GET_AUTO_SUGGEST("", self.$constants.QUERY_ACTION.DEGREE)
        .then(function(response) {
          self.degreeItems = [];
          self.degreeItems = response;
        })
        .catch(function() {});
    },
    addnewDegrees() {
      const self = this;
      self.newDegrees.unshift({
        degree: self.degreeItems[0],
        major: undefined
      });
    },
    deleteNewRow(index) {
      if (this.newDegrees.length > 0) {
        this.newDegrees.splice(index, 1);
      }
    },
    pageOneCompleted() {
      const self = this;
      if(typeof self.title === "object") {
          self.pages[0].title = !!(
              self.title &&
              this.title.job_title.length > 3 &&
              this.title.job_title.length < 128
          );
      } else {
          self.pages[0].title = !!(
              self.title &&
              this.title.length > 3 &&
              this.title.length < 128
          );
      }

    },
    pageTwoCompleted() {
      const self = this;
      self.pages[1].details = !!(self.job_description && FILTERS.REMOVE_WHITE_SPACES(self.job_description).length >= 10 && FILTERS.REMOVE_WHITE_SPACES(self.job_description).length < 10000 && self.job_responsibilities.length < 10000);
    },
    pageThreeCompleted() {
      const self = this;
      self.pages[2].skills = self.reqSkills.length > 0 && self.reqSkills.length < 21 && self.nice_to_have.length < 10000;
    },
    pageFourCompleted() {
      const self = this;
      if(self.maxSalary && self.minSalary) {
        self.pages[3].item = !!(self.job_benefits.length < 10000) && (parseInt(self.minSalary, 10) <= parseInt(self.maxSalary, 10))
      } else {
        self.pages[3].item = !!(self.job_benefits.length < 10000)
      }
    },
    pageFiveCompleted() {
      const self = this;
      self.pages[4].item = !!(self.location && self.location.length > 0 && self.location.length < 300);
    },
    returnJobObject() {
      const self = this;
      let newJob = {};
      let opening = self.opening + " 00:00:00";
      let deadLine = self.deadline + " 23:59:59";
      let fullOpening = new Date(opening).toISOString();
      let fullDeadLine = new Date(deadLine).toISOString();
      newJob.open_date =
        self.formatDate(fullOpening.substr(0, 10)) +
        " " +
        fullOpening.substr(11, 8);
      newJob.close_date =
        self.formatDate(fullDeadLine.substr(0, 10)) +
        " " +
        fullDeadLine.substr(11, 8);
      if (typeof self.title === "object" && self.title.job_title_id) {
        newJob.job_title = FILTERS.REMOVE_WHITE_SPACES(self.title.job_title);
        newJob.job_title_id = self.title.job_title_id;
      } else {
        newJob.job_title = FILTERS.REMOVE_WHITE_SPACES(self.title);
      }
      newJob.position_type = self.position_type;
      newJob.seniority_level = self.seniority_level;
      newJob.job_description = FILTERS.REMOVE_WHITE_SPACES(
        self.job_description
      );
      newJob.rich_job_description = self.details;
      newJob.skills = self.reqSkills;
      newJob.negotiable = self.negotiable ? 1 : 0;
      newJob.salary_basis = self.salaryBasis;
      newJob.allow_message = self.allow_message ? 1 : 0;
      if (self.no_of_vacancy) {
        newJob.no_of_vacancy = parseInt(self.no_of_vacancy, 10);
      }
      if (self.job_responsibilities.length > 0) {
        newJob.job_responsibilities = FILTERS.REMOVE_WHITE_SPACES(
          self.job_responsibilities
        );
        newJob.rich_job_responsibilities = self.responsibilities;
      }
      if (self.newDegrees.length > 0) {
        newJob.degrees = [];
        let i;
        for (i = 0; i < self.newDegrees.length; i++) {
          let temp = {
            degree_name: self.newDegrees[i].degree.degree_name,
            degree_id: self.newDegrees[i].degree.degree_id
          };
          if (self.newDegrees[i].major) {
            if (typeof self.newDegrees[i].major === "object") {
              temp.major_name = self.newDegrees[i].major.major_name;
              temp.major_id = self.newDegrees[i].major.major_id;
            } else {
              temp.major_name = self.newDegrees[i].major;
            }
          }
          newJob.degrees.push(temp);
        }
      }
      if (self.nice_to_have.length > 0) {
        newJob.nice_to_have = FILTERS.REMOVE_WHITE_SPACES(self.nice_to_have);
        newJob.rich_nice_to_have = self.niceToHave;
      }
      if (self.minSalary) {
        newJob.min_salary = parseInt(self.minSalary, 10);
      }
      if (self.maxSalary) {
        newJob.max_salary = parseInt(self.maxSalary, 10);
      }
      if (self.job_benefits.length > 0) {
        newJob.job_benefits = FILTERS.REMOVE_WHITE_SPACES(self.job_benefits);
        newJob.rich_job_benefits = FILTERS.REMOVE_WHITE_SPACES(self.benefits);
      }
      if (self.location) {
        newJob.location_name = FILTERS.REMOVE_WHITE_SPACES(self.location);
      }
      if (self.req_id) {
        newJob.req_id = self.req_id;
      }
      return newJob;
    },
    populateData(job) {
      const self = this;
      if (job.job_title_id) {
        self.title = {
          job_title: job.job_title,
          job_title_id: job.job_title_id
        };
      } else {
        self.title = job.job_title;
      }
      self.pages[0].title = true;
      self.position_type = job.position_type;
      self.seniority_level = job.seniority_level;
      let i, j;
      for (i = 0; i < job.position_type.length; i++) {
        for (j = 0; j < self.positions.length; j++) {
          if (
            self.positions[j].name.toLowerCase() ===
            job.position_type[i].toLowerCase()
          ) {
            self.positions[j].value = true;
            self.pages[0].type = true;
          }
        }
      }
      for (i = 0; i < job.seniority_level.length; i++) {
        for (j = 0; j < self.experiences.length; j++) {
          if (
            self.experiences[j].name.toLowerCase() ===
            job.seniority_level[i].toLowerCase()
          ) {
            self.experiences[j].value = true;
            self.pages[0].level = true;
          }
        }
      }
      self.details = job.rich_job_description;
      self.job_description = job.job_description;
      self.reqSkills = job.skills;
      self.negotiable = !!job.negotiable;
      self.salaryBasis = job.salary_basis;
      self.allow_message = !!job.allow_message;
      if (job.open_date) {
        let tDate = new Date(
          self.parseDate(GET_LOCAL_TIME_FROM_UTC(job.open_date))
        ).getTime();
        if (tDate > new Date().getTime()) {
          self.openingDateFormatted = GET_LOCAL_TIME_FROM_UTC(job.open_date);
          self.opening = self.parseDate(self.openingDateFormatted);
          if (job.close_date) {
            self.deadlineDateFormatted = GET_LOCAL_TIME_FROM_UTC(
              job.close_date
            );
            self.deadline = self.parseDate(self.deadlineDateFormatted);
          }
        }
      }
      if (job.no_of_vacancy) {
        self.no_of_vacancy = parseInt(job.no_of_vacancy, 10);
      }
      if (job.job_responsibilities) {
        self.job_responsibilities = job.job_responsibilities;
        self.responsibilities = job.rich_job_responsibilities;
      }
      if (job.degrees) {
        let i;
        for (i = 0; i < job.degrees.length; i++) {
          let temp = {
            degree: {
              degree_name: job.degrees[i].degree_name,
              degree_id: job.degrees[i].degree_id
            }
          };
          if (job.degrees[i].major_name && job.degrees[i].major_id) {
            temp.major = {
              major_name: job.degrees[i].major_name,
              major_id: job.degrees[i].major_id
            };
          } else if (job.degrees[i].major_name) {
            temp.major = job.degrees[i].major_name;
          } else {
            temp.major = undefined;
          }
          self.newDegrees.push(temp);
        }
      }
      if (job.nice_to_have) {
        self.nice_to_have = job.nice_to_have;
        self.niceToHave = job.rich_nice_to_have;
      }
      if (job.min_salary) {
        self.minSalary = parseInt(job.min_salary, 10);
      }
      if (job.max_salary) {
        self.maxSalary = parseInt(job.max_salary, 10);
      }
      if (job.job_benefits) {
        self.benefits = job.rich_job_benefits;
        self.job_benefits = job.job_benefits;
      }
      if (job.req_id) {
        self.req_id = "" + job.req_id;
      }
      if (job.location_name) {
        self.location = job.location_name;
      }
      self.pageOneCompleted()
      self.pageTwoCompleted();
      self.pageThreeCompleted();
      self.pageFourCompleted();
      self.pageFiveCompleted()
    },
    openPreviewModal() {
      const self = this;
      self.jobObj = self.returnJobObject();
      self.prevCheck++;
      self.previewModal = true;
    },
    saveJob() {
      const self = this;
      self.loading = true;
      self.submitted = true;
      let job = self.returnJobObject();
      let constants = self.$constants;
      let method = constants.METHOD.POST;
      job.action = "save";
      self.message = "Job circular saved in draft";
      if (self.existingJob) {
        method = constants.METHOD.PUT;
        job.job_id = self.job.job_id;
        job.user_id = self.job.user_id;
        job.action = "draftEdit";
        self.message = "Job circular updated successfully";
      }
      POST_A_JOB(job, method)
        .then(function(response) {
          self.loading = false;
          if (response.status === 200) {
            self.successful = true;
            self.goToPending = false;
            self.color = "#155724";
          }
        })
        .catch(function(err) {
          self.loading = false;
          self.successful = false;
          self.message = err.message;
          self.color = "#C82333";
        });
    },
    publishJob: function() {
      const self = this;
      self.loading = true;
      self.submitted = true;
      let job = self.returnJobObject();
      let constants = self.$constants;
      let method = constants.METHOD.POST;
      self.message =
        "You've successfully posted the job. This job is currently in pending state for admin moderation. Please contact us at info@workd.ai";
      job.action = "publish";
      if (self.existingJob) {
        method = constants.METHOD.PUT;
        job.job_id = self.job.job_id;
        job.user_id = self.user_id;
        self.message = "Job circular updated successfully";
        job.action = "pendingEdit";
      }
      POST_A_JOB(job, method)
        .then(function(response) {
          self.loading = false;
          if (response.status === 200) {
            self.goToPending = true;
            self.successful = true;
            self.color = "#155724";
          }
        })
        .catch(function(err) {
          self.loading = false;
          self.successful = false;
          self.message = err.message;
          self.color = "#C82333";
        });
    },
    adminJobPost: function() {
      const self = this;
      let job = self.returnJobObject();
      job.job_source = self.job_source;
      self.$emit("admin-job-post", job, self.user);
    },
    cancelJobPosting() {
      this.$emit("cancel-job-posting");
    },
    goBackToPreview() {
      const self = this;
      self.submitted = false;
    },
    goToPendingJob() {
      const self = this;
      if (self.existingJob) {
        self.$router.go(0);
      } else {
        self.$router.push({ name: "pendingJobs" }).catch(function() {});
      }
    },
    goToDraftJob() {
      const self = this;
      if (self.existingJob) {
        self.$router.go(0);
      } else {
        self.$router.push({ name: "draftJobs" }).catch(function() {});
      }
    },
    changePostingUser() {
      const self = this;
      self.$emit("change-user");
    },
    fetchJobInfoUsingUrl() {
      const self = this;
      if (self.urlLink) {
        self.loading = true;
        IMPORT_JOB_USING_URL(FILTERS.REMOVE_WHITE_SPACES(self.urlLink))
          .then(function(resp) {
            self.resetAllValues();
            let job = {
              job_title: resp.data.job_title
            };
            if (resp.data.nice_to_have) {
              job.rich_nice_to_have = resp.data.nice_to_have;
              job.nice_to_have = REMOVE_HTML_TAGS(resp.data.nice_to_have);
            }
            if (resp.data.job_benefits) {
              job.rich_job_benefits = resp.data.job_benefits;
              job.job_benefits = REMOVE_HTML_TAGS(resp.data.job_benefits);
            }
            if (resp.data.job_description) {
              job.rich_job_description = resp.data.job_description;
              job.job_description = REMOVE_HTML_TAGS(resp.data.job_description);
            }
            if (resp.data.no_of_vacancy) {
              job.no_of_vacancy = resp.data.no_of_vacancy;
            }
            if (resp.data.job_responsibilities) {
              job.rich_job_responsibilities = resp.data.job_responsibilities;
              job.job_responsibilities = REMOVE_HTML_TAGS(
                resp.data.job_responsibilities
              );
            }
            if (resp.data.location_name) {
              job.location_name = resp.data.location_name;
            }
            job.position_type = [];
            if (resp.data.position_type) {
              let position = resp.data.position_type.toLowerCase().split(",");
              let res = [];
              for (let i = 0; i < position.length; i++) {
                let x = REMOVE_WHITE_SPACES(position[i].replace("-time", "time"));
                res.push(x);
              }
              job.position_type = res;
            }
            job.seniority_level = [];
            job.skills = [];
            job.negotiable = self.negotiable;
            job.salary_basis = self.salaryBasis;
            self.populateData(job);
            self.loading = false;
          })
          .catch(function() {
            self.loading = false;
            self.snackbar = true;
            self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
            self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
            self.timeOut = 10000;
            self.snackMessage =
              "Sorry this job can not be pulled from this site. Please contact us for further information.";
          });
      }
    }
  },
  watch: {
    opening() {
      this.openingDateFormatted = this.formatDate(this.opening);
      let minTime = new Date(this.setMinDeadLine()).getTime();
      let maxTime = new Date(this.setMaxDeadLine()).getTime();
      let deadTime = new Date(this.deadline).getTime();
      if (deadTime < minTime || deadTime > maxTime) {
        let tomorrow = new Date(this.opening);
        tomorrow.setDate(tomorrow.getDate() + 29);
        this.deadline = tomorrow.toISOString().substr(0, 10);
      }
    },
    deadline() {
      this.deadlineDateFormatted = this.formatDate(this.deadline);
    },
    titleQuery(val) {
      val && this.queryTitle(val);
    },
    skillQuery(val) {
      val && this.querySkills(val);
    },
    reqSkills(val, prev) {
      this.pages[2].skills = val.length > 0 && val.length < 21;
      if (val.length === prev.length) return;
      this.reqSkills = val.map(v => {
        if (typeof v === "string") {
          v = {
            skill_name: v.trim()
          };
        }
        return v;
      });
    }
  },
  computed: {
    salaryRangeErrors() {
      const errors = [];
      this.pageFourCompleted()
      if (parseInt(this.minSalary, 10) > parseInt(this.maxSalary, 10)) {
        errors.push("Must be greater than minimum salary");
      }
      return errors;
    },
    showPreview() {
      const self = this;
      if (
        self.pages[0].completed() &&
        self.pages[1].completed() &&
        self.pages[2].completed() &&
        self.pages[3].completed() &&
        self.pages[4].completed()
      ) {
        self.pages[5].icon = "mdi-check-circle";
        self.pages[5].text = "Job preview ready";
        self.pages[5].valid = true;
        return true;
      }
      self.pages[5].icon = "mdi-close-circle-outline";
      self.pages[5].text = "Job preview is not ready";
      self.pages[5].valid = false;
      return false;
    }
  },
  beforeDestroy(){
    clearTimeout(this.timeout)
  },
  mounted: function() {
    const self = this;
    self.fetchDegrees();
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    self.opening = tomorrow.toISOString().substr(0, 10);
    tomorrow.setDate(tomorrow.getDate() + 29);
    self.deadline = tomorrow.toISOString().substr(0, 10);
    if (self.job) {
      self.existingJob = true;
      if (self.from) {
        if (self.from.toLowerCase() === "draft") {
          self.showDraft = true;
          self.showPublish = false;
        } else if (self.from.toLowerCase() === "pending") {
          self.showDraft = false;
          self.showPublish = true;
        } else if (self.from.toLowerCase() === "closed") {
          self.showDraft = true;
          self.showPublish = true;
          self.existingJob = false;
          delete self.job.open_date;
          delete self.job.close_date;
          delete self.job.company_id;
          delete self.job.company_name;
          delete self.job.job_id;
          delete self.job.user_id;
        } else {
          self.showDraft = true;
          self.showPublish = true;
        }
      }
      self.populateData(self.job);
    } else {
      // self.addnewDegrees()
    }
    if (self.user) {
      if (self.from.toLowerCase() === "admin") {
        self.job_source = self.job_sources[0].value;
        self.isAdmin = true;
        self.showDraft = false;
        self.showPublish = false;
      }
    }
  }
};
</script>

<style scoped>
.main-form {
  height: 90vh;
  overflow: auto;
}
.sub-form {
  margin: auto !important;
  max-width: 80rem;
}
.usr-wrap {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
}
.usr {
  padding: 1rem !important;
  border: 1px solid #e6e6e6;
}
.link-back {
  text-decoration: underline;
  font-size: 1.2rem !important;
  color: #0766ff;
  cursor: pointer;
}
.s-header {
  margin-bottom: 2rem !important;
  margin-top: 1rem !important;
}
.s-body {
  padding: 3rem;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
}
.bTop {
  margin-top: 9.5rem !important;
}
.preview {
  margin-top: 9.5rem;
  margin-bottom: 3rem;
  padding-top: 2rem;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
}
.previewIcon {
  padding: 1rem;
}
.previewText {
  font-size: 1.2rem;
  padding: 0 0.5rem 3rem 0.5rem;
}
.buttons {
  pointer-events: none;
  opacity: 0.5;
  color: var(--button-color);
}
.activePreview {
  pointer-events: all;
  opacity: 1;
}
.icon-right-butons {
  margin-bottom: 0.1rem;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  color: var(--button-color);
}
.right-button {
  border-top: 0.1rem solid #e6e6e6;
  padding: 1rem;
  cursor: pointer;
  text-align: left;
}
.right-button:hover .icon-right-butons {
  color: #ffffff;
}
.right-button:hover {
  background-color: var(--button-color);
  color: #ffffff;
}
.next-button {
  text-align: right;
}
.btm {
  padding-bottom: 3rem;
}
.numH {
  padding: 1rem;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
  min-width: 10rem;
  cursor: pointer;
}
.active {
  border-bottom: 0.3rem solid #0766ff;
}
.completeH {
  color: var(--success);
}
.complete {
  color: var(--success);
}
.gap {
  display: none;
}
.ttl-job {
  text-align: left;
  font-size: 1.6rem;
  color: #050505;
}
.ttl-inp {
  text-align: left;
  padding: 0.5rem 0;
}
.chips {
  margin: 1rem 0 3rem 0 !important;
}
.selectChip {
  padding: 0.75rem 2rem;
  background-color: var(--synop-select-color);
  margin-right: 1rem;
  color: #050505;
  margin-bottom: 1rem;
  cursor: pointer;
  border-radius: 0.4rem;
}
.selectChip:hover {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  transition: 0.4s;
}
.activeChip {
  background-color: var(--button-color);
  color: white;
}
.salary {
  margin-bottom: 2rem !important;
}
.info-icon-class {
  margin-left: 0.75rem;
  margin-bottom: 0.3rem;
  font-size: 16px;
  color: var(--button-warning);
}
.card-padding {
  padding: 1rem;
  max-height: 90vh;
  overflow-y: scroll;
  background-color: #ffffff;
}
.v-input {
  font-size: 1.4rem !important;
  text-align: right !important;
}
.v-radio {
  margin-right: 0;
}
.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0.2rem;
}
@media (max-width: 1366px) {
  .main-form {
    padding: 0rem;
  }
  .gap {
    display: block;
    width: 100%;
    height: 2rem;
  }
}
@media (max-width: 600px) {
  .gap {
    display: none;
  }
  .main-form {
    padding: 0rem;
  }
  .progress {
    margin: 0 2rem;
  }
}
.message-box-wrapper {
  height: 80vh;
  padding: 1rem;
  box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.16);
}
.message-box {
  margin: 10%;
}
.suc-text {
  font-size: 2rem;
  color: var(--button-save-color);
}
.failure {
  font-size: 2rem;
  color: var(--button-delete-color);
}
.form-control {
  height: 3.5rem;
  border-radius: 0.4rem;
  border: solid 1px #c0c0c0;
  background-color: white;
  font-size: 1.4rem;
  padding: 0 0.5rem;
}
.form-control:focus {
  border: solid 1px #c0c0c0;
  box-shadow: none;
}
.find-jobs-button {
  margin-left: -12rem;
  cursor: pointer;
  width: 14.6rem;
  height: 3.5rem;
  border-radius: 0.4rem;
  background-color: var(--secondary-color);
  color: white;
  z-index: 10;
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
}
</style>
